export class ResponseApiModel {
  data?: any;
  id?: string;
  success: boolean;
  error: {
    code: number,
    description: string
  };
  meta?: any;
}

